import capitalize from 'utils/capitalize';

export default value =>
  !value ? '' : capitalize(value.replace(/_/g, ' '));
